<template>
  <!-- 약관동의 -->
  <v-bottom-sheet
    v-model="sheet"
    scrollable
    persistent
    no-click-animation
    :overlay-opacity="0.7"
    content-class="bottom-sheet"
  >
    <v-card class="card-terms-agree">
      <v-card-title>
        <v-checkbox
            v-model="allCheck"
            label="전체 약관 동의하기"
            :ripple="false"
            hide-details
            class="checkbox-circle-black ma-0"
            @change="allCheckState"
            >
        </v-checkbox>
        <v-btn icon @click="goToPrevPage"> <Close /></v-btn>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-column gap-2">
          <div class="d-flex justify-space-between align-center">
              <v-checkbox
                  v-model="terms[0]"
                  label="[필수] 서비스 이용 약관"
                  :ripple="false"
                  hide-details
                  class="checkbox-line"
                  @change="termsCheck"
                  >
              </v-checkbox>
              <v-btn plain icon :ripple="false" @click="$emit('termsDetailsOpen',0)">
				<img :src="getImage('ic_arrow_right4.svg')">
			</v-btn>
          </div>
          <div class="d-flex justify-space-between align-center">
              <v-checkbox
                  v-model="terms[1]"
                  label="[필수] 개인정보 수집 및 이용 동의"
                  :ripple="false"
                  hide-details
                  class="checkbox-line"
                  @change="termsCheck"
                  >
              </v-checkbox>
              <v-btn plain icon :ripple="false" @click="$emit('termsDetailsOpen',1)"><img :src="getImage('ic_arrow_right4.svg')"></v-btn>
          </div>
          <div class="d-flex justify-space-between align-center ">
              <v-checkbox
                  v-model="terms[2]"
                  label="[선택] 마케팅 수신 동의"
                  :ripple="false"
                  hide-details
                  class="checkbox-line"
                  @change="termsCheck"
                  >
              </v-checkbox>
              <v-btn plain icon :ripple="false" @click="$emit('termsDetailsOpen',2)"><img :src="getImage('ic_arrow_right4.svg')"></v-btn>
          </div>
          <div class="d-flex justify-flex-start align-center ">
            <v-checkbox
                v-model="sms"
                label="SMS/MMS"
                :ripple="false"
                hide-details
                class="checkbox"
                @change="termsCheck"
                style="margin-left: 30px"
                >
            </v-checkbox>
            <v-checkbox
                v-model="email"
                label="이메일"
                :ripple="false"
                hide-details
                class="checkbox"
                @change="termsCheck"
                style="margin-left: 30px"
                >
            </v-checkbox>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <BlackBtn x-large str="다음" @click="next" :disabled="!(terms[0] && terms[1])"></BlackBtn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close';
import BlackBtn from "@/components/btns/BlackBtn";
export default {
  props: {
    sheet: Boolean,
  },
    data: ()=> ({
        allCheck:false,
        terms:[false,false,false],
        division:'',
        sms:false,
        email:false
    }),
	mounted() {
		this.division = this.$route.params.division
	},
  watch: {
    sms(v1, v2) {
      console.log("v1, v2 : ", v1, v2)
      if(v1){
        this.terms[2] = true
      }else{

        this.allCheck = false

        if(!this.email){
          this.terms[2] = false
        }
      }
    },

    email(v1, v2) {
      console.log("v1, v2 : ", v1, v2)
      if(v1){
        this.terms[2] = true
      }else{

        this.allCheck = false

        if(!this.sms){
          this.terms[2] = false
        }
      }
    },

    terms: {
        handler: function () {
          if(this.terms[2] && !this.sms && !this.email){
            this.sms = true
            this.email = true
          }else{
            this.sms = false
            this.email = false
          }
          // console.log("this.terms watch end: ", this.terms)
        },
        deep: true,
        immediate: true,
    },
  },
	computed:{
	},
	components: {
		BlackBtn,
		Close
	},
	methods: {
		goToPrevPage() {
			this.prevPage();
		},
		allCheckState(e){
			if(e){
				this.terms = [true,true,true]
        // this.sms = true
        // this.email = true

			}else{
				this.terms = [false,false,false]
        // this.sms = false
        // this.email = false
			}
		},
		termsCheck(){
			let result = this.terms.every(function(value) {
				return value;
			})

			if(this.allCheck && !result){
				this.allCheck = false;
			}
		},
		next() {
			this.$emit('joinNext', this.terms, this.sms, this.email);
		}
  },
};
</script>
